<template>
  <router-link
    class="teacher-item"
    :to="{
      name: 'ShowTeachersDetaial',
      params: { id: data.teacher_id },
      query: { route_name: 'ShowTeachers', route_label: '名师' },
    }"
  >
    <div class="wrap">
      <img class="avatar" :src="data.teacher_avatar" />
      <div class="name">{{ data.teacher_name }}</div>
      <div class="introduction">{{ data.introduction }}</div>
      <div
        class="tag"
        v-if="
          data.level_name && $store.state.commonSetting.switch_oto_module == 1
        "
      >
        约课
      </div>
      <div class="arrow"></div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "RecommendTeacherItem",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.teacher-item {
  &:nth-child(4n) {
    .wrap {
      margin-right: 0;
    }
  }
}
.wrap {
  width: 239px;
  float: left;
  margin-right: 81px;
  text-align: center;
  box-sizing: border-box;
  position: relative;
}
.avatar {
  width: 116px;
  height: 116px;
  background: rgba(229, 231, 232, 1);
  border: 1px solid #f0f0f0;
  border-radius: 50%;
  display: block;
  margin: 0 auto 23px auto;
  border: 1px solid #f3f3f3;
}
.name {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 18px;
}
.level {
  height: 43px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(140, 140, 140, 1);
  line-height: 43px;
  letter-spacing: 4px;
}
.introduction {
  font-size: 16px;
  color: #666666;
  line-height: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tag {
  position: absolute;
  width: 48px;
  height: 23px;
  background: $primary-color;
  font-size: 14px;
  color: white;
  line-height: 23px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 11px 11px 11px 0;
  top: 0;
  right: 25px;
}
.arrow {
  width: 0;
  height: 0;
  border: 18px solid transparent;
  border-top-color: rgba($color: #f0f0f0, $alpha: 0.61);
  position: absolute;
  left: 50%;
  top: -32px;
  transform: translateX(-50%);
  display: none;
}
</style>
